const agvLine = new URL('../../icons/agv-line.png', import.meta.url).href

export default {
  type: 'AGV Line',
  description: 'AGV Line',
  icon: agvLine,
  group: 'ACS',
  model: {
    type: 'AGVLine',
    left: 200,
    top: 100,
    width: 100,
    height: 20
  }
}
